import client from "./client";

export const getCompanyPage = () => client.post("/companypage/getPage");
export const addCompanyPage = (payload) =>
  client.post("/companypage/addpage", payload);
export const updateCompanyPage = (payload) =>
  client.post("/companypage/updatePage", payload);
export const deleteCompanyPage = () =>
  client.post("/companypage/deletePage");
